import { render, staticRenderFns } from "./formSubscriptionRightsOfINETW2.vue?vue&type=template&id=89060174&scoped=true"
import script from "./formSubscriptionRightsOfINETW2.vue?vue&type=script&lang=js"
export * from "./formSubscriptionRightsOfINETW2.vue?vue&type=script&lang=js"
import style0 from "./formSubscriptionRightsOfINETW2.vue?vue&type=style&index=0&id=89060174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89060174",
  null
  
)

export default component.exports